import { useState } from "react";
import { Link } from "react-router-dom";
import { Loader2, MailCheck, ArrowLeft } from "lucide-react";
import { api } from "../lib/api";
import { formatApiErrorDetail } from "./AuthPage";

export default function ForgotPasswordPage() {
  const [email, setEmail] = useState("");
  const [sent, setSent] = useState(false);
  const [busy, setBusy] = useState(false);
  const [error, setError] = useState("");

  const submit = async () => {
    if (!email.trim()) return;
    setBusy(true);
    setError("");
    try {
      await api.post("/auth/forgot-password", { email: email.trim(), origin_url: window.location.origin });
      setSent(true);
    } catch (e) {
      setError(formatApiErrorDetail(e.response?.data?.detail) || e.message);
    }
    setBusy(false);
  };

  return (
    <div className="min-h-screen flex items-center justify-center px-5">
      <div className="w-full max-w-md space-y-5">
        <img src="/mascot.png" alt="StudySpark mascot" className="w-20 h-20 mx-auto rounded-full border-4 border-black shadow-[4px_4px_0px_rgba(0,0,0,1)] bg-white object-cover" />
        <div className="bg-white border-2 border-black rounded-2xl shadow-[6px_6px_0px_rgba(0,0,0,1)] p-6 space-y-4" data-testid="forgot-password-card">
          {sent ? (
            <div className="text-center space-y-3">
              <MailCheck size={36} className="mx-auto text-[#51CF66]" />
              <h1 className="font-heading text-2xl font-semibold">Check your email</h1>
              <p className="text-sm text-gray-600">If <b>{email}</b> has a StudySpark account, a reset link is on its way. It works for 1 hour.</p>
            </div>
          ) : (
            <>
              <h1 className="font-heading text-2xl font-semibold">Forgot your password?</h1>
              <p className="text-sm text-gray-600">Enter your account email and we'll send you a reset link.</p>
              <input
                type="email"
                className="w-full bg-white border-2 border-black rounded-xl px-4 py-3 focus:outline-none focus:ring-4 focus:ring-[#FFE066]/50 text-base"
                placeholder="Email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                onKeyDown={(e) => e.key === "Enter" && submit()}
                data-testid="forgot-email-input"
              />
              {error && <p className="text-sm font-bold text-[#FF6B6B]" data-testid="forgot-error">{error}</p>}
              <button onClick={submit} disabled={busy} data-testid="forgot-submit-button"
                className="w-full bg-[#4D96FF] border-2 border-black rounded-full shadow-[4px_4px_0px_rgba(0,0,0,1)] active:shadow-none active:translate-y-1 transition-all font-bold py-3 disabled:opacity-60 flex items-center justify-center gap-2">
                {busy && <Loader2 size={18} className="animate-spin" />} Send reset link
              </button>
            </>
          )}
          <Link to="/auth" data-testid="forgot-back-link" className="flex items-center justify-center gap-1.5 text-sm font-bold text-gray-500 hover:text-black transition-colors">
            <ArrowLeft size={15} /> Back to log in
          </Link>
        </div>
      </div>
    </div>
  );
}
